module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'customers'
      }
    }
  }, [_vm._v("Customers")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View Customer")])])])]), _vm._v(" "), _c('section', {
    staticClass: "content customers-content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-form', {
    ref: "customer",
    attrs: {
      "model": _vm.customer,
      "rules": _vm.rules,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_vm._v(_vm._s(_vm.customer.name))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Api key",
      "prop": "customerSecretKey"
    }
  }, [_vm._v(_vm._s(_vm.customer.customerSecretKey))])], 1), _vm._v(" "), _c('hr')], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fe8d22e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/customers/View.vue
// module id = 1161
// module chunks = 2